import axios from "axios";

import { basePath, createHeaders } from "./utils";
import { setToLocalStorage, removeFromLocalStorage, getFromLocalStorage } from "../utils/storage";

/**
 * POST
 * /api/auth/logout
 * 
 * Logout to system
 */
export const userLogout = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(`${basePath}/auth/logout`, null, config)
      .then((resp) => {
        axios.defaults.headers.common.Authorization = null;
        removeFromLocalStorage("authData");
        resolve(resp);
      })
      .catch((err) => {
        console.error(err);
        axios.defaults.headers.common.Authorization = null;
        removeFromLocalStorage("authData");
        reject(err);
      });
  });
};

/**
 * POST
 * /api/auth/login
 * 
 * Login to system
 */
export const userLogin = (email, password) => {
  const config = {};
  config.headers = createHeaders();
  config.headers["Authorization"] =
    "Basic " + window.btoa(`${email}:${password}`);

  return new Promise((resolve, reject) => {
    axios
      .post(`${basePath}/auth/login`, null, config)
      .then((resp) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + resp.data.token;
        setToLocalStorage("authData", resp.data);
        resolve(resp);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
